import React from 'react';
import { ZapIcon } from 'lucide-react';
import { useActivityPlan } from '../../contexts/ActivityPlanContext';
import { activityById } from '../../data/activityCatalog';
import { contactTypeMeta } from '../../data/contacts';
import { activityIconClasses } from '../../utils/activityStyles';
interface RecentLogListProps {
  limit?: number;
  title?: string;
}
function dayLabel(daysAgo: number): string {
  if (daysAgo === 0) return 'Today';
  if (daysAgo === 1) return 'Yesterday';
  if (daysAgo < 7) return `${daysAgo} days ago`;
  if (daysAgo < 30) return `${Math.round(daysAgo / 7)} weeks ago`;
  return `${Math.round(daysAgo / 30)} months ago`;
}
export function RecentLogList({
  limit = 8,
  title = 'Recent activity log'
}: RecentLogListProps) {
  const {
    logs
  } = useActivityPlan();
  const entries = logs.slice(0, limit);
  return <section aria-labelledby="recent-log-heading" className="rounded-2xl border border-navy-100 bg-white shadow-card" data-id="element-155" data-mp="zda1197sjwmb">
      <header className="border-b border-navy-100 px-5 py-4" data-id="element-156" data-mp="dacoessaxd06">
        <h2 id="recent-log-heading" className="text-sm font-semibold text-navy-900" data-id="element-157" data-mp="dbxhsf2vqpwg">
          {title}
        </h2>
        <p className="mt-0.5 text-xs text-navy-500" data-id="element-158" data-mp="8hjja3sx82nk">
          Everything you and the system have credited
        </p>
      </header>

      {entries.length === 0 ? <p className="px-5 py-8 text-center text-sm text-navy-500" data-id="element-159" data-mp="3vpn9flq5ewbm">
          Nothing logged yet. Use the +1 buttons to get started.
        </p> : <ol className="divide-y divide-navy-100" data-id="element-160" data-mp="ra47h7xodjl1">
          {entries.map(entry => {
        const definition = activityById[entry.category];
        const Icon = definition.icon;
        return <li key={entry.id} className="flex gap-3 px-5 py-3" data-id="element-161" data-mp="i9z1n284qt8z">
                <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${activityIconClasses[definition.tone]}`} data-id="element-162" data-mp="ibs9ulye5lj3">
                  <Icon className="h-4 w-4" aria-hidden="true" data-id="element-163" data-mp="32y3nhu26345x" />
                </span>
                <div className="min-w-0 flex-1" data-id="element-164" data-mp="34i573g89ynm0">
                  <div className="flex flex-wrap items-center gap-2" data-id="element-165" data-mp="39fwxg5t9u1o3">
                    <p className="text-sm font-semibold text-navy-900" data-id="element-166" data-mp="39f5cdoxavmc2">
                      +{entry.count} {definition.shortLabel}
                    </p>
                    {entry.source === 'prompt' ? <span className="inline-flex items-center gap-1 rounded-full bg-brand-50 px-2 py-0.5 text-[11px] font-bold uppercase tracking-wide text-brand-700 ring-1 ring-brand-200" data-id="element-167" data-mp="2zjtvp12c051o">
                        <ZapIcon className="h-3 w-3" aria-hidden="true" data-id="element-168" data-mp="2qj5j8asl6cqw" />
                        Prompted
                      </span> : null}
                  </div>
                  {entry.contact ? <div className="mt-0.5 flex flex-wrap items-center gap-1.5" data-id="element-169" data-mp="22ri3mp0ryo3x">
                      <p className="text-xs font-semibold text-navy-700" data-id="element-170" data-mp="22tug4mnrk69l">
                        {entry.contact.name}
                      </p>
                      <span className={`inline-flex items-center rounded-full px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide ring-1 ${contactTypeMeta[entry.contact.type].classes}`} data-id="element-171" data-mp="1o3zv1fk3d9c8">
                        {contactTypeMeta[entry.contact.type].label}
                      </span>
                    </div> : <p className="mt-0.5 text-xs text-navy-400" data-id="element-172" data-mp="2733wa25e5ytc">
                      No contact attached
                    </p>}
                  <p className="text-xs text-navy-500" data-id="element-173" data-mp="224an2lx50tyz">
                    {dayLabel(entry.daysAgo)} · {entry.timeLabel}
                    {entry.channel ? ` · ${entry.channel}` : ''}
                  </p>
                  {entry.note ? <p className="mt-1 text-xs text-navy-600" data-id="element-174" data-mp="2ptlqkb5vh2gt">{entry.note}</p> : null}
                </div>
              </li>;
      })}
        </ol>}
    </section>;
}